// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"86a20568","453":"9e6d203a"}[chunkId] + ".chunk.js";
};